import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["href"]

import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManagePipelinesPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminManagePipelinesPage',
  setup(__props) {

    document.title = "Manage pipelines"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useAllPipelinesQuery } = useAdminManagePipelinesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { model, run } = useAllPipelinesQuery(tid)
    const pipelines = computed(() => model.value?.Pipelines || [])
    run()

    onMounted(() => {
        runCurrentUserQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Manage pipelines", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/create/${_unref(tid)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Create pipeline ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pipelines.value, (p) => {
        return (_openBlock(), _createElementBlock("div", {
          key: p.Id
        }, [
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${p.PipelineId}`
          }, _toDisplayString(p.Name), 9 /* TEXT, PROPS */, _hoisted_7)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})